<template>
  <div class="p-report-download-list">
    <LoadingChara v-if="isLoading" variant="inline">
      <template slot="title">
        データ取得中
      </template>
    </LoadingChara>
    <Error v-else-if="!items.length" img="search" variant="inline">
      <template slot="title">
        レポートは翌月月初4～9日の間に作成されます。
      </template>
    </Error>
    <template v-else>
      <ListItemReportSite
        v-for="item in limitedItems"
        :key="item.id"
        :item="item"
        :project="project"
        @download="download"
      />
      <Pager
        v-if="hasPages"
        :limit="params.limit"
        :offset="params.offset"
        :total="items.length"
        @change="updateOffset"
      />
    </template>
  </div>
</template>

<script>
import Error from '@/components/Error';
import ListItemReportSite from '@/components/reportDownload/ListItemReportSite';
import LoadingChara from '@/components/LoadingChara';
import Pager from '@/components/Pager';

export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    project: {
      type: Object,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    }
  },
  components: {
    Error,
    ListItemReportSite,
    LoadingChara,
    Pager
  },
  data() {
    return {
      params: {
        offset: 0,
        limit: 12
      }
    };
  },
  computed: {
    limitedItems() {
      return this.items.slice(
        this.params.offset,
        this.params.offset + this.params.limit
      );
    },
    hasPages() {
      return this.items.length > this.params.limit;
    }
  },
  methods: {
    download() {
      this.$emit('download');
    },
    updateOffset(offset) {
      this.params.offset = offset;
    }
  }
};
</script>
